import { render, staticRenderFns } from "./useCourse.vue?vue&type=template&id=6f4bc478&scoped=true&"
import script from "./useCourse.vue?vue&type=script&lang=js&"
export * from "./useCourse.vue?vue&type=script&lang=js&"
import style0 from "./useCourse.vue?vue&type=style&index=0&id=6f4bc478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4bc478",
  null
  
)

export default component.exports